import React from "react"
import { SelectInput } from "ra-ui-materialui"
import Storage from "lib/storage"

export default function LayoutInput(props) {
  const layouts = Object.values(Storage.getObject("controllerLayouts"))
  return <SelectInput choices={layouts} {...props} />
}